import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/taggedTemplateLiteralLoose";
var _templateObject;
import styled from 'styled-components';
export * from "./Document.js";
export * from "./Divider.js";
export * from "./Result.js";
export * from "./Button.js";
export * from "./CodeLineCopy.js";
export * from "./CheckboxOption.js";
export * from "./Spacing.js";
export * from "./Select.js";
export * from "./Input.js";
export * from "./StyledLayout.js";
export * from "./Textarea.js";
export * from "./utils.js";
export * from "./ErrorLayout.js";
export * from "./CodeEditor.js";
export * from "./LayoutEditorConverter.js";
export var Wrapper = styled.main(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  padding: 25px;\n  width: 100%;\n  min-height: 100%;\n  display: flex;\n  gap: 25px;\n"])));